// This infers types from a sample
// Used by the script-input component
export const getTypeDefinition = (input: any): string => {
  if (Array.isArray(input)) {
    return input.length > 0 ? `${getTypeDefinition(input[0])}[]` : '[]'
  }
  if (input && typeof input === 'object') {
    const values = Object.keys(input)
      .map(key => `${safeObjectKey(key)}: ${getTypeDefinition(input[key])}`)
      .join(', ')

    return `{${values}}`
  }
  return typeof input
}

const safeObjectKey = (key: string) => {
  if (/^[$a-z_][0-9a-z_$]*$/i.test(key)) {
    // safe as is
    return key
  }
  // needs quotes
  return `'${key}'`
}
